var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[(_vm.app.webVersion == 2)?_c('configuratorsV2Component'):_c('configuratorsV1Component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }